import { Navbar } from "../Navbar";
import "./Header.scss";

const Header = () => (
  <header className="bg-white fixed w-full z-[100]">
    <Navbar />
  </header>
);

export default Header;
